import React from 'react'
import {useSelector} from 'react-redux'
import {selectIsCookiesAcceptedByUser} from 'modules/cookies/selectors'
import {getIsSyntheticTest} from 'modules/meta/selectors'
import {getIsFromKayak} from 'utils/trafficSource'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {GoogleOneTap} from '@vio/shared/src/authentication/GoogleOneTap'

export const GoogleOneTapWrapper = () => {
  const {auth} = useBrandCapabilities()
  const isCookiesAcceptedByUser = useSelector(selectIsCookiesAcceptedByUser)
  const isSyntheticTest = useSelector(getIsSyntheticTest)
  const isKayakTraffic = useSelector(getIsFromKayak)

  if (!auth.hasGoogleOneTap || isSyntheticTest || isKayakTraffic) return null

  return <GoogleOneTap isCookiesAcceptedByUser={isCookiesAcceptedByUser} />
}
